export default "__VITE_PUBLIC_ASSET__ae44541d__"